import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-view-assessment-cost',
  templateUrl: './view-assessment-cost.component.html',
  styleUrls: ['./view-assessment-cost.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})


export class ViewAssessmentCostComponent {

  report = input.required<any>();

  constructor() { }
}
